module.exports = __webpack_public_path__ + "static/KIN0-fc9cf326dec139caf1f80ddd56a98219.jpg";